import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
    isAuthenticatedSelector,
} from 'redux/auth/authSelectors';
import { useNavigate, useLocation } from 'react-router-dom';
import useAuthenticateFromCookies from './useAuthenticateFromCookies';

const publicURLs = ['activation', 'impressum', 'disclaimer', 'datenschutz', 'kontakt', 'reset-password', 'bfsg-explanation'];

const useAuthenticationRedirect = () => {
    const isAuthenticated = useSelector(isAuthenticatedSelector);
    const [isLoading, setIsLoading] = useState(true);
    const { pathname } = useLocation();
    const navigate = useNavigate();

    const { cookiesCkecked } = useAuthenticateFromCookies();

    const publicURL = useCallback(
        () => publicURLs.some((pathName) => pathname.includes(pathName)),
        [pathname],
    );

    const tryRedirect = useCallback(async () => {
        if (publicURL() && cookiesCkecked) {
            setIsLoading(false);

            return;
        }

        if (cookiesCkecked && !isAuthenticated) {
            navigate('/login');
            setIsLoading(false);
        }

        if (isAuthenticated) {
            setIsLoading(false);
        }
    }, [isAuthenticated, cookiesCkecked, publicURL]);

    useEffect(() => {
        tryRedirect();
    }, [tryRedirect]);

    return { isLoading };
};

export default useAuthenticationRedirect;
